export default {
  title: 'Seat arrangements',
  description: 'Bind a seat layout and roster to each meeting, then open Adjust seats to arrange seating.',
  addButton: 'Add arrangement',
  addTitle: 'Add seat arrangement',
  index: 'No.',
  meetingScope: 'Meeting',
  meetingPlaceholder: 'Select a meeting',
  wholeActivity: 'Whole activity (all meetings)',
  wholeActivityHint: 'When there is no separate meeting, choose “Whole activity (all meetings)”.',
  layout: 'Seat layout',
  scrollVenue: 'Scroll to choose a venue',
  prevVenue: 'View previous venues',
  nextVenue: 'View next venues',
  createLayout: 'Create seat layout',
  createLayoutHint: 'Add a venue and arrange seats',
  emptyLayoutPreview: 'Empty venue',
  emptyLayoutTypes: 'No seat types',
  layoutThumbnailAria: '{name} layout preview',
  approvedPeople: 'Approved registrations',
  approvedPeopleHint: 'After choosing a meeting or the whole activity, approved registrations in that scope will be loaded.',
  approvedPeopleWholePrefix: 'Approved registrations for the whole activity',
  approvedPeopleMeetingPrefix: 'Approved registrations for this session',
  approvedPeopleCountSuffix: 'people',
  approvedStatus: 'Approved',
  loadingRoster: 'Loading registrations…',
  rosterLoadFailed: 'Failed to load registrations. Please try again.',
  noApprovedPeopleWhole: 'No approved registrations for this activity',
  noApprovedPeopleMeeting: 'No approved registrations for this session',
  rosterSourceLabel: 'Roster source',
  rosterSourceHint: 'Use approved registrations for this activity/session, or download the template and import a roster.',
  rosterSourceRegistrationWhole: 'Whole-activity registrations',
  rosterSourceRegistrationMeeting: 'Meeting registrations',
  rosterSourceImported: 'Imported roster',
  importedPeoplePrefix: 'Imported attendees',
  importedPeopleCountSuffix: 'people',
  importedTag: 'Imported',
  rosterEmptyImported: 'No imported roster yet. Download the template, fill it in, and upload it.',
  clearImported: 'Clear imported roster',
  previewTruncated: 'Showing the first {count} of {total}',
  types: 'Seat types',
  seatCount: '· {count} seats',
  seatCountLabel: 'Seats',
  assigned: 'Assigned',
  emptySeats: 'Empty',
  roster: 'Roster',
  rosterCount: '{count} people',
  rosterSource: 'Roster source',
  registrationRoster: 'Approved meeting registrations',
  registrationRosterHint: 'Approved registrations will be loaded when the roster is configured.',
  rearrange: 'Rearrange',
  adjust: 'Adjust seats',
  rearrangeTitle: 'Rearrange seats',
  rearrangeSessionHint: 'The meeting session is fixed. Rearranging only changes the seat layout.',
  rearrangeRosterHint: 'Rearranging clears the existing roster and seat assignments, then rebuilds them from the roster source selected below.',
  rearrangeConfirm: 'The existing roster and seat assignments will be cleared and recreated with the new roster and layout. Continue?',
  rearrangeSuccess: 'Seat arrangement updated',
  complete: 'Complete',
  saving: 'Saving…',
  createSuccess: 'Seat arrangement created',
  emptyList: 'No seat arrangements yet',
  noLayouts: 'No seat layouts available',
  autoCopy: 'Auto copy',
  lastSaved: 'Last saved',
  notSaved: 'Not saved yet',
  activityRequired: 'Create an activity first'
}
